<template>
  <main v-if="this.$store.state.siteAccess">
    <sidenav />
    <div id="matters">
      <transition name="fade" appear>
        <router-view></router-view>
      </transition>
    </div>
  </main>
  <div v-else>
    <div id="matters" class="no-access">
      <section>
        <h2>Jason Jun's Portfolio Website</h2>
        <p>Hello, I put my website under private mode due to some of my works are not allowed to be public.</p>
        <p>If you want to check out my works, please don't hesitate to contact me. I'll give you an access link right away.</p>
        <p>You can reach me on Twitter <a href="https://twitter.com/jsonjun">@jsonjun</a> or email me at uxd.jun@gmail.com</p>
      </section>
    </div>
  </div>
</template>

<script>
import Sidenav from '@/components/Sidenav.vue'

export default {
  name: 'app',
  components: {
    'sidenav': Sidenav
  },
  created () {
    let routePath = this.$route.path
    let accessPath = routePath.slice(-7)
    let actualPath = routePath.slice(0, -7)

    if (accessPath === '/access') {
      this.$store.commit('accessGrant')
      this.$router.push(actualPath)
    }
  }
}
</script>

<style lang="scss">
/* Router transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.fade-enter {
  min-height: 100%;
}


/* Global styles */
* {
  font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

html {
  background-color: $color-black;
}

body {
  background-color: #fff;
}

ul, ol {
  list-style: none;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}

figure {
  margin: 0;
}

h1, h2, h3, h4, h5 {
  margin: 0;
  font-weight: 500;
  color: $color-black;

  &::selection {
    background-color: $color-black;
    color: #fff;
  }

  & span::selection {
    background-color: $color-black;
    color: #fff;
  }
}

ul, li {
  margin: 0;
  color: $color-black;
}

h1 {
  font-size: 2.5rem;
  letter-spacing: -0.1rem;
  line-height: 4.4rem;

  @include device(mobile) {
    font-size: 2rem;
    letter-spacing: -0.05rem;
    line-height: 4rem;
  }
}

h2 {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: -0.02rem;

  @include device(mobile) {
    font-size: 1.3rem;
    line-height: 1.8rem;
  }
}

p {
  font-size: 1rem;
  line-height: 1.5rem;
}

small {
  font-size: 14px;
  color: #969696;
  line-height: 12px;
  display: inline-block;
  width: auto;
  height: 60px;
  margin-top: -60px;
  border-left: 1px solid #ccc;
  padding-left: 20px;
  transform: rotate(90deg);
  transform-origin: bottom left;
  position: absolute;
  left: 0;
  overflow: hidden;

  @include device(laptop) {
    transform: none;
    position: relative;
    height: 40px;
    margin-top: 0;
    margin-bottom: 40px;
  }

  @include device(mobile) {
    padding-left: 10px;
  }

  & span {
    display: inline-block;
    position: relative;
  }
}

#matters {
  transition: all 0.4s cubic-bezier(.43,.24,.3,1);

  &.opened {
    transform: translateX(-300px);
  }
}

</style>

<style lang="scss" scoped>
  .no-access {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    & section {
      max-width: 540px;
    }

    & h2 {
      margin-bottom: 3rem;
    }

    & p {
      opacity: 0.4;
    }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue